// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_-X7lP"};